import { Constants } from '../constants'

const initialState = {
    user: {},
    payload: {},
    history: {},
    redirect: '',
    akoaldeSend: {},
    referrals: []
}

function userReducer(state = initialState, action) {
    switch (action.type) {
        case Constants.LOGIN_REQUEST_SUCCESS:
            return {
                ...state,
                user: { ...action.payload },
                payload: action.payload,
                redirect: ''
            }
        case Constants.USER_GET_SUCCESS:
            return {
                ...state,
                user: { ...state.user, ...action.payload }
            }
        case Constants.ALL_TRANSACTION_SUCCESS:
            return {
                ...state,
                history: action.payload,
                payload: { ...action.payload }
            }

        case Constants.GET_AKOLADE_SEND_SUCCESS:
            return {
                ...state,
                akoaldeSend: action.payload.data,
                payload: { ...action.payload }
            }
        case 'GET_AKOLADE_SEND_UPDATE':
            return newUpdate(state, action)

        case Constants.NEW_ACCESS_TOKEN_SUCCESS:
            return {
                ...state,
                user: {
                    ...state.user,
                    authorization: action.payload.authorization
                },
                payload: { ...action.payload }
            }

        case 'LOGIN_REDIRECT':
            return {
                ...state,
                redirect: action.payload
            }
        case Constants.PROFILE_UPDATE_SUCCESS:
        case Constants.PASSWORD_CHANGE_SUCCESS:
        case Constants.SIGNUP_REQUEST_SUCCESS:
        case Constants.FORGOT_PASSWORD_SUCCESS:
        case Constants.CHANGE_PASSWORD_SUCCESS:
        case Constants.ACCESS_HISTORY_SUCCESS:
        case Constants.ACCESS_HISTORY_FAILURE:
        case Constants.LOGIN_REQUEST_FAILURE:
        case Constants.CHANGE_PASSWORD_FAILURE:
        case Constants.FORGOT_PASSWORD_FAILURE:
        case Constants.ALL_TRANSACTION_FAILURE:
        case Constants.SIGNUP_REQUEST_FAILURE:
        case Constants.PASSWORD_CHANGE_FAILURE:
        case Constants.PROFILE_UPDATE_FAILURE:
        case Constants.EMAIL_SUBSCRIPTION_SUCCESS:
        case Constants.EMAIL_SUBSCRIPTION_FAILURE:
        case Constants.USERDEACTIVATE_SUCCESS:
        case Constants.USERDEACTIVATE_FAILURE:
        case Constants.USER_GET_FAILURE:
        case Constants.REPORT_FAKE_SUCCESS:
        case Constants.REPORT_FAKE_FAILURE:
        case Constants.CANCEL_AKOLADE_SUCCESS:
        case Constants.CREATE_APP_SUCCESS:
        case Constants.CREATE_APP_FAILURE:
        case Constants.GET_APP_LIST_SUCCESS:
        case Constants.GET_APP_LIST_FAILURE:
        case Constants.CONFIRM_TXN_FAILURE:
        case Constants.CONFIRM_TXN_SUCCESS:
        case Constants.APP_PAYMENT_SUCCESS:
        case Constants.APP_PAYMENT_FAILURE:
            return {
                ...state,
                payload: { ...action.payload }
            }

        case Constants.GET_USERS_REFERRALS_SUCCESS:
        case Constants.GET_USERS_REFERRALS_FAILURE:
            return {
                ...state,
                referrals: action.payload.data
            }

        case Constants.LOGOUT:
            return initialState
        default:
            return state
    }
}

const newUpdate = (state, action) => {
    var newState = { ...state }
    var arrayObj = (newState.akoaldeSend.donations = state.akoaldeSend.donations.slice())
    var element = (arrayObj[action.payload.rowIndex] = {
        ...arrayObj[action.payload.rowIndex]
    })
    element.status = 'cancelled'
    return newState
}
export default userReducer
